module.exports = __webpack_public_path__ + "static/globalwar_china-8e38854ba177ece2e611038e937d7800.jpeg";